export function getCookie(cookieName: string): string | undefined {
  for (const cv of document.cookie.split(';')) {
    const [name, value] = cv.split(/=(.*)/s).map(v => v.trim())
    if (name == cookieName) {
      return decodeURIComponent(value)
    }
  }
}
